import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { OrderStatus } from '../../../shared/enums';
import { OrderNumber } from '../../../shared/types';
import { PublicOrderContextOperationsResponse } from './public-order-context-operations.response';
import { RefundSummaryResponse } from '../../../shared/api/responses';

@jsonObject
export class PublicOrderCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: OrderNumber;

  @jsonMember(String)
  public readonly status!: OrderStatus;

  @jsonMember(Number)
  public readonly totalItems!: number;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonMember(RefundSummaryResponse)
  public readonly refundSummary?: Nillable<RefundSummaryResponse>;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(PublicOrderContextOperationsResponse)
  public readonly contextOperations!: PublicOrderContextOperationsResponse;
}
